define(
    [
        'underscore',
        'backbone'
    ],
    function(
        _,
        Backbone,
    ) {
        const TEMPLATE = '<img src="<%- src%>">';

        return Backbone.View.extend({
            initialize: function() {
                this.template = _.template(TEMPLATE);
                this.listenTo(this.model, "change", this.render);

                this.render();
            },

            render: function() {
                if (this.model.get('src')) {
                    this.$el.html(
                        this.template(
                            this.model.toJSON()
                        )
                    );
                } else {
                    this.$el.html('');
                }

                return this;
            }
        })
    }
);
